import React, { Component } from "react";
import { Spin, Menu } from 'antd';
import { getDevicesList } from "../../action/device.action";
import { connect } from 'react-redux'
import ScannerInfoCard from "./scannerinfocard"

class ScannersListComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            devices: []
        }
    }

    componentWillMount() {
        this.props.dispatch(getDevicesList())
    }

    render() {

        var itemList = [];

        if (this.props.isFetching === true) {
            itemList = <Spin spinning={true}><Menu.Item onItemHover={null} onClick={null} /></Spin>;
        } else {
            this.props.deviceList.map((device, index) => (    
                itemList.push(
                    <ScannerInfoCard name={device.name} id={device.id} key={device.id} {...this.props}/>
                )
            ))
        }

        return itemList;
    }
}

const mapStateToPropsScannerList = (state) => {
    return {
        isFetching: state.deviceAlert.isFetching,
        deviceList: state.deviceAlert.deviceData
    }
}

export default connect(mapStateToPropsScannerList)(ScannersListComp);